var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M35.7855 17.0854L42.5563 11.7104C44.3584 10.2812 44.6584 7.65833 43.2292 5.85625C41.8001 4.05416 39.1772 3.75416 37.3751 5.18333L26.6959 13.6604L18.7667 19.9562L17.7876 15.3187C17.1084 12.1 13.948 10.0417 10.7292 10.7208C9.65633 10.9479 8.97091 12 9.19799 13.0729L12.1397 27.0042L12.6855 26.8896C12.2667 28.8792 12.6709 31.0271 14.0334 32.7437L23.5334 44.7125C25.1584 46.7583 28.1334 47.1 30.1792 45.4771L41.0251 36.8687C43.448 34.9458 44.1001 31.5375 42.5563 28.8562L35.7855 17.0854Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5042 45.0479C28.0167 44.4333 14.2667 27.1479 13.7772 26.5333C12.7292 25.2125 10.8084 24.9917 9.48757 26.0396C8.16674 27.0875 7.9459 29.0083 8.99382 30.3292C9.48132 30.9438 23.2313 48.2292 23.7209 48.8438C24.7688 50.1646 26.6897 50.3854 28.0105 49.3375C29.3334 48.2896 29.5542 46.3688 28.5042 45.0479Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0834 8.33335C26.55 8.33335 26.0167 8.12918 25.6104 7.72293C24.7959 6.90835 24.7959 5.59168 25.6104 4.7771L27.6938 2.69376C28.5084 1.87918 29.825 1.87918 30.6396 2.69376C31.4542 3.50835 31.4542 4.82501 30.6396 5.6396L28.5563 7.72293C28.15 8.12918 27.6167 8.33335 27.0834 8.33335Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7501 8.33333C17.598 8.33333 16.6667 7.40208 16.6667 6.25V2.08333C16.6667 0.93125 17.598 0 18.7501 0C19.9022 0 20.8334 0.93125 20.8334 2.08333V6.25C20.8334 7.40208 19.9022 8.33333 18.7501 8.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasy);
export default __webpack_public_path__ + "static/media/easy.d2e339065b40c62fd163e3112ddf394b.svg";
export { ForwardRef as ReactComponent };